import { render } from "./AdministratorShowComponent.vue?vue&type=template&id=5b153101"
import script from "./AdministratorShowComponent.vue?vue&type=script&lang=js"
export * from "./AdministratorShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/administrators/AdministratorShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b153101"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b153101', __exports__)) {
    api.reload('5b153101', __exports__)
  }
  
  module.hot.accept("./AdministratorShowComponent.vue?vue&type=template&id=5b153101", () => {
    api.rerender('5b153101', render)
  })

}


export default __exports__